import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - Datezy uygulaması ile aynı proje (datezy-production)
const firebaseConfig = {
  apiKey: "AIzaSyB3sbwmd0p_rV-K7aMT-YjccI3UaSzlj8s",
  authDomain: "datezy-production.firebaseapp.com",
  projectId: "datezy-production",
  storageBucket: "datezy-production.firebasestorage.app",
  messagingSenderId: "300381412405",
  appId: "1:300381412405:web:datezy-admin"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services for admin panel
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app; 